module.exports = __webpack_public_path__ + "media/icons/caret-d0d7b52753025ae1141836b6fa6a130f.svg";